import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import { setPageType, isClientADesktop } from "../../utils";
import {
  pageType,
  HEADER_HEIGHT,
  OVERFLOW_HIDDEN,
  OVERFLOW_AUTO,
  PIXEL_SCROLLED_LIMIT,
} from "npmlinks-constants";
import StoreList from "../../component/StoreList";
import StoreLocatorForm from "../../component/StoreLocatorForm";
import { StoreLocatorMap } from "../../component/GoogleMap";
import Analytics from "../../analytics";

@inject("StoreListStore", "CommonStore")
@observer
class StoreLocator extends Component {
  static contextTypes = {
    router: PropTypes.shape({
      staticContext: PropTypes.object,
    }),
  };

  constructor(props) {
    super(props);

    this.stickStoreCount.bind(this);
  }

  componentWillMount() {
    // this is only available when rendering on the server
    const { isDesktop } = this.props.CommonStore;
    this.mapState = isDesktop;
  }

  componentDidMount() {
    const { isDesktop } = this.props.CommonStore;

    window.scrollTo(0, 0);
    setPageType(pageType.storeLocator);
    Analytics.pageView(window.pageType);
    const storeForm = document.querySelector(".nwc-storeform-container");
    if (isDesktop) {
      storeForm.addEventListener("scroll", this.stickStoreCount, false);
    } else {
      window.addEventListener("scroll", this.stickStoreCount, false);
    }
  }

  componentWillUnmount() {
    const { isDesktop } = this.props.CommonStore;

    const storeForm = document.querySelector(".nwc-storeform-container");
    if (isDesktop) {
      storeForm.removeEventListener("scroll", this.stickStoreCount);
    } else {
      window.removeEventListener("scroll", this.stickStoreCount);
    }
  }

  get formState() {
    return !this.props.StoreListStore.states.showForm ? "nwc-hide" : "";
  }

  get mapState() {
    return !this.props.StoreListStore.states.showMap ? "nwc-hide" : "";
  }

  set mapState(isShowMap) {
    this.props.StoreListStore.states.showMap = isShowMap;
  }

  get mapViewForDesktop() {
    const { isDesktop } = this.props.CommonStore;

    return isDesktop
      ? "nwc-grid-col-sm-4 nwc-grid-col-lg-3 nwc-left-panel-desktop"
      : "nwc-grid-col-xs-12 nwc-left-panel";
  }

  get listViewForDesktop() {
    const { isDesktop } = this.props.CommonStore;

    return isDesktop ? "nwc-storeform-container-desktop" : " ";
  }

  stickStoreCount() {
    const { isDesktop } = this.props.CommonStore;
    let storeForm = document.body;
    let form = document.querySelector(".nwc-right-panel");
    let offsetTop = form.offsetHeight;
    let className = "nwc-fixed";
    if (isDesktop) {
      storeForm = document.querySelector(".nwc-storeform-container");
      form = document.querySelector(".nw-storelocatorform");
      offsetTop = form.offsetHeight;
      className = "nwc-absolute";
    } else {
      offsetTop += HEADER_HEIGHT; // add header's height
    }
    const scrolledPixels = storeForm.scrollTop;
    const storeCountElem = document.querySelector(".nw-store-list-heading");
    if (scrolledPixels > offsetTop) {
      storeForm.style.paddingTop = "60px";
      storeCountElem.classList.add(className);
    } else {
      storeCountElem.classList.remove(className);
      if (isDesktop) {
        storeForm.style.paddingTop = "24px";
      } else {
        storeForm.style.paddingTop = "0";
      }
    }
  }

  render() {
    return (
      <GridContainer className="nw-storelocator-container">
        <GridRow className="nw-storelocator-row">
          <GridColumn
            className={`nwc-grid-col-sm-12 nwc-grid-col-lg-12 nwc-right-panel ${
              this.mapState
            }`}
          >
            <StoreLocatorMap.component />
          </GridColumn>
          <GridColumn className={`${this.mapViewForDesktop}`}>
            <div
              className={`nwc-custom-scrollbar nwc-storeform-container ${
                this.listViewForDesktop
              } `}
            >
              <StoreLocatorForm.component className={this.formState} />
              <StoreList.component />
            </div>
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

StoreLocator.wrappedComponent.propTypes = {
  StoreListStore: PropTypes.shape({
    states: PropTypes.object.isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("StoreListStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: StoreLocator.wrappedComponent,
  component: StoreLocator,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/StoreLocator/index.js